module.exports = __webpack_public_path__ + "img/_images.40a5d8c1.svg";